import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { loadContainers } from '@eika-infrastruktur/render';

import Kalkulator from './containers/Kalkulator';
import { defaultConfig } from './default-config';
import getCssVariableValue from './util/getCssVariableValue';

import './i18n';
import './styles/main.scss';

const globalCssNamespace = 'kreditt-boliglaankalkulator-frontend';

export const REPO_NAMESPACE = 'kreditt';

const staleTime = 60 * 60 * 5 * 1000; // 5 min
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime,
            retry: 1,
        },
    },
});

const renderApp = (
    MyApp: React.ComponentType,
    namespace: string,
    appDefaultConfig: Record<string, unknown> = defaultConfig,
): void => {
    loadContainers(
        `${REPO_NAMESPACE}.${namespace}`,
        () => (
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <SkeletonTheme
                        baseColor={getCssVariableValue('--neutral-background')}
                        highlightColor={getCssVariableValue('--card-background-light')}
                    >
                        <div className={globalCssNamespace}>
                            {process.env.NODE_ENV === 'development' && (
                                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
                            )}
                            <MyApp />
                        </div>
                    </SkeletonTheme>
                </QueryClientProvider>
            </React.StrictMode>
        ),
        appDefaultConfig,
    );
};

renderApp(Kalkulator, 'boliglaankalkulator.kalkulator-view');
